import React from "react";
const events = [
  {
    month: "กันยายน 2024",
    items: [
      {
        day: "19",
        date: "วันพุธ",
        time: "14:00 น. - 16:30 น.",
        title: "ประชุมสัมมนาวิชาการการป้องกันภัยคุกคามทางไซเบอร์",
      },
      {
        day: "21",
        date: "วันพฤหัส",
        time: "9:30 น. - 12:00 น.",
        title: "ประชุมสัมมนาวิชาการการป้องกันภัยคุกคามทางไซเบอร์",
      },
      {
        day: "26",
        date: "วันศุกร์",
        time: "10:20 น. - 11:30 น.",
        title: "ประชุมสัมมนาวิชาการการป้องกันภัยคุกคามทางไซเบอร์",
      },
    ],
  },
  {
    month: "ตุลาคม 2024",
    items: [
      {
        day: "8",
        date: "วันอังคาร",
        time: "13:00 น. - 15:30 น.",
        title: "สรุปรายงานงบประมาณประจำปี 2566",
      },
      {
        day: "9",
        date: "วันพุธ",
        time: "08:00 น. - 10:00 น.",
        title: "ประชุมสัมมนาวิชาการการป้องกันภัยคุกคามทางไซเบอร์",
      },
    ],
  },
];
const NewsLists = () => {
  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="text-lg font-semibold mb-4">กิจกรรมล่าสุด</div>
      {events.map((eventMonth, index) => (
        <div key={index} className="mb-6">
          <div className="text-gray-600 font-medium  pb-1 mb-2">
            {eventMonth.month}
          </div>
          {eventMonth.items.map((event, idx) => (
            <div
              key={idx}
              className={`flex items-start py-4 ${idx !== 0 && "border-t"}`}
            >
              <div className="flex-shrink-0 text-center w-16">
                <div className="text-lg font-bold text-purple-600">
                  {event.day}
                </div>
                <div className="text-sm text-gray-500">{event.date}</div>
              </div>
              <div className="ml-4">
                <div className="text-sm text-gray-500">{event.time}</div>
                <div className="text-base font-medium">{event.title}</div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default NewsLists;
